export default class AppFile {
    constructor (
        id,
        filename,
        status,
        progress,
        properties = {},
        thumbUrl = null,
        deleteUrl = null,
        deliverUrl = null
    ) {
        this.id = id;
        this.filename = filename;
        this.status = status;
        this.progress = progress;
        this.properties = properties;
        if (id && thumbUrl) {
            this.thumb_url = thumbUrl.replace('file_id', id);
        }
        if (id && deleteUrl) {
            this.delete_url = deleteUrl.replace('file_id', id);
        }
        if (id && deliverUrl) {
            this.deliver_url = deliverUrl.replace('file_id', id);
        }
    }

    static STATUS_WAIT () {
        return 'wait';
    };

    static STATUS_PROGRESS () {
        return 'progress';
    };

    static STATUS_ERROR () {
        return 'error';
    };

    static STATUS_SUCCESS () {
        return 'success';
    };

    static STATUS_UPLOADED () {
        return 'uploaded';
    };
}



// WEBPACK FOOTER //
// ./resources/assets/js/objects/file.js